<template>
  <div class="skills-root">
    <p class="title is-4">Умения</p>

    <div v-if="loading" class="notification is-light">
      Загрузка умений…
    </div>

    <div v-else-if="mySkills.length === 0" class="notification is-light">
      У вас пока нет изученных умений.
    </div>

    <div
      v-else
      v-for="userSkill in mySkills"
      :key="userSkill.id"
      class="box"
    >
      <div class="content">
        <p>
          <strong>{{ userSkill.skill.name }}</strong>
          <span class="tag is-light is-rounded ml-2">{{ kindLabel(userSkill.skill.kind) }}</span>
          <span v-if="userSkill.value > 0" class="tag is-info is-light is-rounded ml-2">
            {{ userSkill.value }}
          </span>
        </p>
        <p v-if="userSkill.skill.description" class="has-text-grey">
          {{ userSkill.skill.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '../services/UserService'

const KIND_LABELS = {
  basic: 'Базовое',
  battle: 'Боевое',
  navigation: 'Навигация',
  exploring: 'Исследование',
  production: 'Производство',
}

export default {
  data () {
    return {
      mySkills: [],
      loading: false,
    }
  },
  mounted () {
    this.loadSkills()
  },
  methods: {
    kindLabel (kind) {
      return KIND_LABELS[kind] || kind
    },
    async loadSkills () {
      this.loading = true
      try {
        const resp = await UserService.getSkills()
        this.mySkills = resp.data || []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.skills-root {
  max-width: 640px;
  margin: 0 auto;
}

.ml-2 {
  margin-left: 0.5rem;
}
</style>
